<template>
  <ul ref="rootEl" role="menu">
    <li v-for="(item, index) in links" :key="index" class="text-blackly" role="menuitem">
      <LinkField
        v-bind="item.link[0]"
        class="py-2 inline-block hover:opacity-60 transition-opacity w-full"
        :active-class="'text-br-green'"
        :class="{
          'fluid-sm tracking-wider font-medium': index === 0,
          'fluid-xs leading-tightest': index !== 0,
          'text-br-red': item.highlight,
        }"
        no-tracking
        @click="handleNavClick(index)"
      >
        {{ item.link[0].text }}
        <sup v-if="item.new" class="text-br-green fluid-xxs uppercase">
          {{ $t('navigation.new') }}
        </sup>
      </LinkField>
    </li>
  </ul>
</template>

<script setup>
import { snakeCase } from 'lodash-es';
import { useMainNavStore } from '@/stores/main-nav';
import LinkField from '@/components/common/LinkField';
import { getNavSegmentFromDOM } from '@/utils/navigationTracking';

const props = defineProps({
  links: {
    type: Array,
    default: () => [],
  },
  startNewColumn: {
    type: Boolean,
    default: true,
  },
});

const rootEl = ref(null);
const mainNavStore = useMainNavStore();
const $_pushNavigationEvent = useNuxtApp().$_pushNavigationEvent;

const getLinkText = (item) => item?.link?.[0]?.text ?? '';

const handleNavClick = (index) => {
  const topLevel = getNavSegmentFromDOM(rootEl.value);
  const sectionLabel = snakeCase(getLinkText(props.links[0]));
  const segment = snakeCase(getLinkText(props.links[index]));

  const pathParts = [topLevel, sectionLabel].filter(Boolean);
  if (index > 0 && segment) pathParts.push(segment);
  const path = pathParts.join('>');

  $_pushNavigationEvent('header', path || 'header');
  mainNavStore.setActiveNavItemIndex(null);
};
</script>
